export const ANNOUNCEMENT_QUERY_KEY = 'announcement';
export const ANNOUNCEMENTS_QUERY_KEY = 'announcements';
